import { proxy } from "valtio";

export const dialogsState = proxy<{
  showWordExportInfo: boolean;
  showWordExportInfoProfileId: string;
}>({
  showWordExportInfo: false,
  showWordExportInfoProfileId: "",
});
